import Vue from 'vue'
import Vuex from 'vuex'
import { getToken, setToken, removeToken, getInfo, setInfo, removeInfo } from '@/utils/auth'
import { login,logout,getUserInfo, wxLoginMember } from '@/api/user'
Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        token: getToken(),
        routerForm: '',
        routerTo: '/',
        userInfo: getInfo(),
		testurlid:'',
    },
    mutations: {
        SET_TOKEN: (state, token) => {
            state.token = token
        },
        SET_USERINFO: (state, info) => {
            state.userInfo = info
        },
        setRouterForm(state, fromName) {
            state.routerForm = fromName
        },
        setRouterTo(state, toName) {
            state.routerTo = toName
        },
		settesturlid(state, id) {
		    state.testurlid = id
		},
    },
    actions: {
        getUserInfo({ commit }){
            getUserInfo({}).then(res=>{
				delete res.groupIds
				delete res.groups
				delete res.menuIds
				delete res.roleIds
				delete res.roles
				delete res.menus
				let info = res
				commit('SET_USERINFO', info)
				info.avatar=''
                setInfo(info)
            })
        },
        wxLogin({ commit }, openid) {
            return new Promise((resolve, reject) => {
                wxLoginMember({ openid }).then(response => {
                    commit('SET_TOKEN', response.token)
                    setToken(response.token)
                    getUserInfo({}).then(res=>{
                        delete res.groupIds
                        delete res.groups
                        delete res.menuIds
                        delete res.roleIds
                        delete res.roles
                        delete res.menus
                        let info = res
                        // info.username=res.chineseName
                        // info.id=res.id
                        info.avatar=''
                        commit('SET_USERINFO', info)
                        setInfo(info)
                        resolve()
                    })
                }).catch(error => {
                    reject(error)
                })
            })
        },
        login({ commit }, userInfo) {
            const { username, password } = userInfo
            return new Promise((resolve, reject) => {
                login({ loginName: username.trim(), password: password }).then(response => {
                    commit('SET_TOKEN', response.token)
                    setToken(response.token)
                    getUserInfo({}).then(res=>{
						console.log(res)
						delete res.groupIds
						delete res.groups
						delete res.menuIds
						delete res.roleIds
						delete res.roles
						delete res.menus
                        let info = res
						// info.chineseName=res.chineseName
						// info.id=res.id
						info.avatar=''
                        commit('SET_USERINFO', info)
                        setInfo(info)
                        resolve()
                    })
                }).catch(error => {
                    reject(error)
                })
            })
        },
        logout({ commit, state }) {
            return new Promise((resolve, reject) => {
                // setTimeout(() => {
                //     commit('SET_TOKEN', '')
                //     commit('SET_USERINFO', {})
                //     removeToken()
                //     removeInfo()
                //     resolve()
                // },300)
                logout(state.token).then(() => {
                    commit('SET_TOKEN', '')
                    commit('SET_USERINFO', '')
                    removeToken()
					removeInfo()
                    resolve()
                }).catch(error => {
                    reject(error)
                })
            })
        },
    },
    getters:{
        token: state => state.token,
        routerForm: state => state.routerForm,
        routerTo: state => state.routerTo,
        userInfo: state => state.userInfo,
		testurlid: state => state.testurlid,
    }
})
